import { useState, useEffect } from 'react'
import { Outlet } from 'react-router'
import Sidebar from '@/components/Sidebar'

const SIDEBAR_COLLAPSED_KEY = 'biging-sidebar-collapsed'

export default function AppLayout() {
  const [collapsed, setCollapsed] = useState(() => {
    return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === 'true'
  })

  useEffect(() => {
    localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(collapsed))
  }, [collapsed])

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(c => !c)} />
      <main className="flex-1 overflow-auto bg-secondary">
        <Outlet />
      </main>
    </div>
  )
}
